module.exports = __webpack_public_path__ + "img/MNT.1d4a535a.svg";